import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    top: theme.custom.sidebarOffset,
    height: `calc(100vh - ${theme.custom.sidebarOffset}px)`,
    overflowY: 'auto',
    paddingBottom: theme.spacing(3),
  },
  normal: {
    width: 280,
  },
  narrow: {
    width: 210,
  },
}));

interface IProps {
  variant?: 'normal' | 'narrow';
}

const StickySidebar: FC<IProps> = ({ children, variant }) => {
  const classes = useStyles();
  const rootClasses = classNames(classes.root, classes[variant]);

  return (
    <div id="sticky-sidebar" className={rootClasses}>
      {children}
    </div>
  );
};

StickySidebar.defaultProps = {
  variant: 'normal',
};

export default StickySidebar;
